import request from 'api/request';

export default function readInvitationRoute(id) {
  return request({ url: `/invitations/${id}`, method: 'GET' });
}
